import * as Sentry from "@sentry/react";

export default function captureException({ error, info = {} }) {
  Sentry.configureScope((scope) =>
    scope.setLevel("error").setExtra("info", JSON.stringify(info))
  );

  return Sentry.captureException(error);
}
